<p-dialog
  #dialogNovoContato
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialog.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">
        {{ data.contato.contato ? 'Editar contato' : 'Adicionar contato' }}
      </span>
      <i class="pi pi-fw pi-phone ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row">
    <viggo-core-custom-input
      [control]="form.get('contato')"
      placeholder="Contato *"
      id="field-contato"
      class="col-md-12 mt-2"
      [error]="displayMessage['contato']"
    ></viggo-core-custom-input>

    <chip-input
      class="col-md-12 mt-2"
      style="width: 100% !important;"
      id="tag-catalogo"
      placeholder="Tags do contato"
      [tagContato]="true"
      [newContato]="!data.contato.id"
      [initialValue]="data.contato.tag"
      (onChange)="onChangeTag($event)"
    ></chip-input>
    <!-- [initialValue]="data.contato.id ? data.contato.tags : data.contato.tag" -->
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        (click)="cancelar()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="salvar()"
        [disabled]="!form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
